import _jsx from "@babel/runtime/helpers/jsx";
import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import SafeAnchor from '../bootstrap/SafeAnchor';
import createChainedFunction from '../bootstrap/utils/createChainedFunction';
class NavItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }
    if (this.props.onSelect) {
      this.props.onSelect(this.props.eventKey, e);
    }
  }
  render() {
    const {
      active,
      disabled,
      onClick,
      className,
      style,
      ...props
    } = this.props;
    delete props.onSelect;
    delete props.eventKey;

    // These are injected down by `<Nav>` for building `<SubNav>`s.
    delete props.activeKey;
    delete props.activeHref;
    if (!props.role) {
      if (props.href === '#') {
        props.role = 'button';
      }
    } else if (props.role === 'tab') {
      props['aria-selected'] = active;
    }
    return /*#__PURE__*/_jsx("li", {
      role: "presentation",
      className: clsx(className, {
        active,
        disabled
      }),
      style: style
    }, void 0, /*#__PURE__*/React.createElement(SafeAnchor, Object.assign({}, props, {
      disabled: disabled,
      onClick: createChainedFunction(onClick, this.handleClick)
    })));
  }
}
NavItem.defaultProps = {
  active: false,
  disabled: false
};
export default NavItem;